import {
  HowToOrderRoot,
  HowToOrderContainer,
  Column,
  Title,
  CardTitle,
  HowToOrderFlex,
} from './HowToOrder.styles'
import { Text } from 'components/Text'
import { Button } from 'components/Button'
import { useTranslation } from 'hooks/useTranslation'
import Link from 'next/link'

export const HowToOrder = ({ protein }: { protein: string }) => {
  const { t } = useTranslation()
  const capitalizedProtein = protein.charAt(0).toUpperCase() + protein.slice(1).toLowerCase()

  return (
    <HowToOrderRoot>
      <HowToOrderContainer>
        <Title align="center" size="h1">
          {t('recipes:frozen-v2.how-to-order.title', { Protein: capitalizedProtein })}
        </Title>
        <HowToOrderFlex>
          <Column>
            <CardTitle>{t('recipes:frozen-v2.how-to-order.custom-meal-plan.label')}</CardTitle>
            <Text size="body" align="center">
              {t('recipes:frozen-v2.how-to-order.custom-meal-plan.description')}
            </Text>
            <Link passHref href="/meal-plan">
              <Button>{t('recipes:frozen-v2.how-to-order.custom-meal-plan.cta')}</Button>
            </Link>
          </Column>
          <Column>
            <CardTitle>{t('recipes:frozen-v2.how-to-order.essential-box.label')}</CardTitle>
            <Text size="body" align="center">
              {t('recipes:frozen-v2.how-to-order.essential-box.description')}
            </Text>
            <Link passHref href="/products/classic-box">
              <Button>{t('recipes:frozen-v2.how-to-order.essential-box.cta')}</Button>
            </Link>
          </Column>
        </HowToOrderFlex>
      </HowToOrderContainer>
    </HowToOrderRoot>
  )
}

HowToOrder.displayName = 'HowToOrder'
